import React from 'react';
import Interactions from './Interactions';

const App = () => <Interactions query_url='https://cms.aimogen.com/_/items/interactions?sort=-asked_on&limit=50&fields=*.*&filter[emotion_transcript][nempty]' videochat={true}/>;

export default App;
